/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { useCallback, useEffect, useState } from 'react';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UsageTracker from '../../../utils/UsageTracker';
import { formatSecondsToTextDuration } from '../../../utils/utils';
import { useExpiredModalState } from '../examsStores';
import { useValidateExam } from '../examsQueries';
import { MS_IN_A_MINUTE } from '../../../constants/TimeConstants';
import { getExamDeadline } from '../examsUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const ONE_SECOND_IN_MS = 1000;
const ExamTimer = ({
  track,
  passive,
  clientStartTime,
  mostRecentExamAttempt
}) => {
  var _track$exam;
  const {
    showExpiredModal,
    setShowExpiredModal
  } = useExpiredModalState();
  const examDeadline = getExamDeadline(track.exam, mostRecentExamAttempt !== null && mostRecentExamAttempt !== void 0 ? mostRecentExamAttempt : undefined);
  const localDeadline = clientStartTime ? clientStartTime + ((track === null || track === void 0 || (_track$exam = track.exam) === null || _track$exam === void 0 ? void 0 : _track$exam.durationMinutes) || 0) * MS_IN_A_MINUTE : null;
  const timerDeadline = localDeadline || examDeadline || 0;
  const [remainingSeconds, setRemainingSeconds] = useState((timerDeadline - Date.now()) / ONE_SECOND_IN_MS);
  const [validateExam] = useValidateExam(track.id, track.language);
  const handleTimeExpired = useCallback(() => {
    const attemptFinished = !!(mostRecentExamAttempt !== null && mostRecentExamAttempt !== void 0 && mostRecentExamAttempt.attemptFinishTime);
    if (mostRecentExamAttempt && !attemptFinished && !passive) {
      var _track$exam2;
      UsageTracker.trackStandalone('Exam Interaction', {
        action: 'time-expired',
        trigger: 'timeout',
        examId: (_track$exam2 = track.exam) === null || _track$exam2 === void 0 ? void 0 : _track$exam2.id,
        examLength: mostRecentExamAttempt.questions.length,
        trackId: track.id,
        trackName: track && track.name,
        examAttemptId: mostRecentExamAttempt.id && mostRecentExamAttempt.id.toString()
      });
      setShowExpiredModal(true);
      return validateExam(mostRecentExamAttempt.id).then(() => {
        var _track$exam3;
        UsageTracker.trackStandalone('Exam Interaction', {
          action: 'completed',
          examId: (_track$exam3 = track.exam) === null || _track$exam3 === void 0 ? void 0 : _track$exam3.id,
          examLength: mostRecentExamAttempt.questions.length,
          trackId: track.id,
          trackName: track && track.name,
          examAttemptId: mostRecentExamAttempt.id && mostRecentExamAttempt.id.toString()
        });
      });
    }
    return null;
  }, [mostRecentExamAttempt, passive, setShowExpiredModal, track, validateExam]);
  useEffect(() => {
    if (showExpiredModal || examDeadline === null) {
      return () => {};
    }
    const interval = setInterval(() => {
      const secondsLeft = (timerDeadline - Date.now()) / ONE_SECOND_IN_MS;
      if (secondsLeft <= 0) {
        clearInterval(interval);
        handleTimeExpired();
      } else {
        setRemainingSeconds(secondsLeft);
      }
    }, ONE_SECOND_IN_MS);
    return () => {
      clearInterval(interval);
    };
  }, [examDeadline, showExpiredModal, handleTimeExpired, timerDeadline]);
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "learningCenter.exams.examQuestion.timeRemaining",
      options: {
        timeRemaining: formatSecondsToTextDuration(remainingSeconds)
      }
    })
  });
};
export default ExamTimer;